// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"19":"blog","40":"debug","75":"mc","472":"settings","792":"main"}[chunkId] + "-" + {"19":"da968","40":"4cb8d","75":"c0d4e","472":"9838e","792":"a85a0"}[chunkId] + ".js";
};